import {handleApiError, itemEmpty} from './common.js'
import itemPayload from '../item-payload.js'
import buildModuleComposite from './composite-item.js'
import {SET_LOADING, SET_ERROR, REM_CHILD} from './composite-item.js'

/**
 *
 * @return {{mutations: {}, state: {}, getters: {}, actions: {}, namespaced: boolean, modules}}
 */
export default function buildModuleCompositeCreate (path, createProperties, createUrl, childCreateUrl, childCreateProperties, childUpdateProperties, childProperty, parsed, prepareChild) {
  const SET_SAVED = 'SET_SAVED'
  // FIXME: RESET action is not overridden here - this is a problem as the child slots will remain the same.
  return buildModuleComposite({
    namespaced: true,
    state: {
      saved: false
    },
    mutations: {
      [SET_SAVED] (state, saved) {
        state.saved = saved
      },
    },
    getters: {
      saved: state => state.saved
    },
    actions: {
      clear ({commit, dispatch, getters}) {
        // Clear previous children.
        getters.childSlots.map((slotName) => {
          this.unregisterModule(path + '/' + slotName)
          commit(REM_CHILD, slotName)
        })
        commit(SET_SAVED, false)
        return dispatch('setItem', itemEmpty(createProperties))
      },

      save ({ commit, dispatch, getters }) {
        commit(SET_ERROR, '')
        commit(SET_LOADING, true)
        if (getters.saved) {
          throw new Error('Create store must be cleared after save before a new item may be saved.')
        }
        return new Promise((resolve, reject) => {
          const saveChildren = (result) => {
            const promisesNew = []
            getters.childSlots.map((childName) => {
              const childData = Object.assign({}, getters[`${childName}/item`])
              // Already saved?
              if (childData['@id']) {
                return
              }
              promisesNew.push(dispatch(`${childName}/setItem`, prepareChild(childData, result)).then(() => {
                return dispatch(`${childName}/save`)
              }))
            })

            Promise.all(promisesNew)
              .then(() => {
                // Load base item again as child updates might have changed it.
                dispatch('api/fetch', {uri: result['@id']}, { root: true })
                  .then(response => response.json())
                  .then((data) => {
                    commit(SET_LOADING, false)
                    commit(SET_ERROR, '')
                    commit(SET_SAVED, true)
                    // FIXME: ensure child slots map the returned data.
                    resolve(data)
                  })
              }, (error) => {
                commit(SET_LOADING, false)
                commit(SET_ERROR, error)
                reject(error)
              })
          }

          // Root item is already saved, must only save missing children.
          if (getters.item['@id']) {
            saveChildren(getters.item)
            return
          }

          dispatch('api/post', { uri: createUrl, options: {
            body: JSON.stringify(itemPayload(createProperties, getters.item))
          }}, { root: true })
            .then(response => response.json())
            .then((result) => {
              dispatch('setItem', result).then(saveChildren)
            })
            .catch(error => {
              commit(SET_LOADING, false)
              handleApiError({commit, dispatch}, error)
              reject(error)
            })
        })
      },
    },
  }, path, createProperties, childCreateUrl, childCreateProperties, childUpdateProperties, parsed, prepareChild)
}
